import { Url } from '@42.nl/react-url';

export const USER_APP_URL = '/users';

export function toUsersApp(): Url {
  return USER_APP_URL;
}
